export enum ClinicalDocumentationType {
    Form = 1,
    Tab = 2,
}
